import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";

const NavBarItemDown = ({ cls }) => {
  return (
    <ul className={cls}>
      <div className="dropdown pt-4 lg:pt-0">
        <button>Quick links</button>
        <div className="z-20 dropdown-content">
          <a href="#1">Who we are?</a>
          <a href="#1">How it's Works?</a>
          <Link to="/faqs">FAQS</Link>
          <a href="#1" className="text-bold">
            How to raise funds
          </a>
        </div>
      </div>
      <div className="dropdown">
        <button>Funding Categories</button>
        <div className="z-20 dropdown-content">
          <a href="#1">DonorAssits Funds</a>
          <a href="#1">COVID-19</a>
          <a href="#1">Animals</a>
          <a href="#1" className="text-bold">
            See More...
          </a>
        </div>
      </div>
      <Link
        className={clsx(
          `border rounded-full px-3 py-1 border-primary hover:bg-primary hover:text-white`
        )}
        to="/"
      >
        Start a Campaign
      </Link>
      <Link
        className={`border rounded-full text-white px-3 py-1 bg-primary border-primary hover:bg-white hover:text-primary`}
        to="/signin"
      >
        Sign In/Sign Up
      </Link>
    </ul>
  );
};

export default NavBarItemDown;
